<template lang="pug">
  v-card(
    color="grey lighten-4"
    flat
    light
  )
    v-row(align="center" no-gutters).py-1
      v-col
        v-card-title.text-body-1.d-flex
          v-icon.mr-2 mdi-clock-outline
          .mr-4 {{ $dp.dateprintDefault(meeting.date_start), }}
          .font-weight-bold {{ meeting.name }}
      v-col Преподователь: {{meeting.teacher.user.full_name}}
      v-card-actions
        v-btn(
          v-if="date(meeting.schedule.date_end) "
          color="secondary"
          text
          disabled
        )
          v-icon.mr-2 mdi-video
          | Трансляция завершена
        v-btn.mr-2(
          v-else
          color="secondary"
          :to=`{
            name: 'Meeting',
            params: {
              id: meeting.id,
            }
          }`
          rounded
          text
          target="_blank"
        )
          v-icon.mr-2 mdi-video
          | Смотреть трансляцию
</template>
<script>
export default {
  props: {
    meeting: { type: Object, required: true },
    isTeacher: { type: Boolean, required: true },
  },
  data() {
    return {};
  },
  methods: {
    date(date) {
      return new Date() > new Date(date);
    },
  },
};
</script>
